// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/smart-text/app/css/app.css
// module id = 591
// module chunks = 0